module.exports = __webpack_public_path__ + "static/media/pl-PL.bc1e45b6.md";